import { Component } from 'react';
import '../../../../../../styles/components/auction-enrollment.scss';
import { CircleArrowDown, BanknoteArrowDown } from 'lucide-react';
import CashFlowTable from '../CashFlowTable';
import CashFlowStatCard from '../CashFlowStatCard';
import Donut from '../Donut';
import { COLORS } from '../../constants/colors';
import i18n from '../../../../../../i18n';
class AuctionEnrollmentSection extends Component {
  render() {
    const { data } = this.props;
    const donutSegments = [
      { value: data?.enrollment?.online?.amount || 0, color: COLORS.teal, label: i18n.t('online') },
      {
        value: data?.enrollment?.offline?.amount || 0,
        color: COLORS.tealMid,
        label: i18n.t('offline'),
      },
    ];

    return (
      <section className="auction-enrollment">
        {/* Cards */}
        <div className="ae-grid">
          <CashFlowStatCard
            icon={<BanknoteArrowDown size={24} strokeWidth={2} />}
            title={i18n.t('enrollment_amount_received')}
            value={data?.enrollment?.sub_total?.amount || 0}
            subtitle={`${data?.enrollment?.sub_total?.count || 0} ${i18n.t('enrollments')}`}
            iconClass="green"
            valueClass="green-text"
            color="#32a852"
          />
        </div>

        {/* Cash Flow IN  */}

        <div className="cashflow in">
          {/* Header */}
          <div className="cf-header">
            <div className="cf-header__left">
              <div className="cf-main-icon green">
                <CircleArrowDown size={20} strokeWidth={1.8} />
              </div>

              <div>
                <h2 className="cf-title">{i18n.t('cash_flow_in')}</h2>

                <p className="cf-subtitle">{i18n.t('total_enrollment_received')}</p>
              </div>
            </div>
          </div>
          <div className="cf-details">
            <CashFlowTable
              search={this.props.search}
              data={[
                {
                  id: 1,
                  method: i18n.t('online'),
                  type: 'online',
                  icon: 'globe',
                  count: data?.enrollment?.online?.count || 0,
                  amount: data?.enrollment?.online?.amount || 0,
                  percentage: 77,
                  color: '#10b981',
                },
                {
                  id: 2,
                  method: i18n.t('offline'),
                  type: 'offline',
                  icon: 'creditCard',
                  count: data?.enrollment?.offline?.count || 0,
                  amount: data?.enrollment?.offline?.amount || 0,
                  percentage: 18,
                  color: '#3b82f6',
                },
              ]}
              totalCount={data?.enrollment?.sub_total?.count || 0}
              totalAmount={data?.enrollment?.sub_total?.amount || 0}
            />
            <Donut segments={donutSegments} />
          </div>
        </div>
      </section>
    );
  }
}

export default AuctionEnrollmentSection;
